import { InputForm, SubmitButton, Error, Textarea } from "components";
import { CreatePackageError, CreatePackageInput } from "../../../store/actionType";
interface FormProps {
  handleSave: (event: React.FormEvent<HTMLButtonElement>) => void;
  formData: CreatePackageInput;
  handleChange: (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => void;
  error: CreatePackageError;
  loading: boolean;
  header:string;
}
const PackageForm: React.FC<FormProps> = ({
  formData,
  handleChange,
  error,
  loading,
  handleSave,
  header
}) => {
  return (
    <section className="w-full flex flex-col items-center justify-center p-4">
      <form className="w-full max-w-screen-md">
        <h2 className="text-2xl font-bold text-center mb-4">{header}</h2>
        <div className="grid grid-cols-1 gap-3">
          <div>
            <InputForm
              label="Package"
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
            />
            {error.name && <Error>{error.name}</Error>}
          </div>
          <div>
            <InputForm
              label="Package Type"
              type="text"
              id="package_type"
              name="package_type"
              value={formData.package_type}
              onChange={handleChange}
            />
            {error.package_type && <Error>{error.package_type}</Error>}
          </div>
          <div>
            <InputForm
              label="Package Order"
              type="text"
              id="package_order"
              name="package_order"
              value={formData.package_order}
              onChange={handleChange}
            />
            {error.package_order && <Error>{error.package_order}</Error>}
          </div>
          <div>
            <Textarea
              label="Description"
              id="description"
              type="text"
              name="description"
              value={formData.description}
              onChange={handleChange}
            />
            {error.description && <Error>{error.description}</Error>}
          </div>
          <div>
            <Textarea
              label="Information"
              id="information"
              type="text"
              rows={10}
              name="information"
              value={formData.information}
              onChange={handleChange}
            />
            {error.information && <Error>{error.information}</Error>}
          </div>
        </div>
        <div className="flex items-center justify-between mt-6">
          <SubmitButton loading={loading} onClick={handleSave} />
        </div>
      </form>
    </section>
  );
};
export default PackageForm;
